import { Outlet, useLocation } from "react-router-dom";
import { usePermissions } from "../helper/PermissionContext";
import AccessDenied from "../pages/AccessDenied/AccessDenied";

const ROUTE_PERMISSIONS = {
  "/": "dashboard",
  "/blog": "blog-management",
  "/add-blog": "blog-management",
  "/edit-blog": "blog-management",
  "/category": "blog-management",
  "/author": "blog-management",
  "/tags": "blog-management",
  "/dynamic-page": "dynamic-page",
  "/add-dynamic-page": "dynamic-page",
  "/edit-dynamic-page": "dynamic-page",
  "/case-study": "case-study",
  "/add-casestudy": "case-study",
  "/edit-casestudy": "case-study",
  "/press": "press-release",
  "/add-press": "press-release",
  "/edit-press": "press-release",
  "/seo": "seo-management",
  "/add-seo": "seo-management",
  "/edit-seo": "seo-management",
  "/global-seo": "global-seo",
  "/sitemap": "sitemap-management",
  "/faq": "faq-management",
  "/add-faq": "faq-management",
  "/edit-faq": "faq-management",
  "/llms": "llms-management",
  "/robots": "robots-management",
  "/email-management": "email-management",
  "/add-email-management": "email-management",
  "/edit-email-management": "email-management",
  "/contact": "contact-us",
  "/users": "user-management",
  "/roles": "user-management",
  "/permissions": "user-management",
};

const permissionForPath = (pathname) => {
  const segments = pathname.split("/").filter(Boolean);
  if (segments.length === 0) return ROUTE_PERMISSIONS["/"];

  for (const [routePath, slug] of Object.entries(ROUTE_PERMISSIONS)) {
    if (routePath === "/") continue;
    const routeSegments = routePath.split("/").filter(Boolean);
    if (routeSegments.every((segment, index) => segments[index] === segment)) return slug;
  }

  return null;
};

export default function RoutePermissionGuard() {
  const { pathname } = useLocation();
  const { status, hasPermission } = usePermissions();
  const requiredPermission = permissionForPath(pathname);

  if (status === "loading") return <div>Loading...</div>;
  if (requiredPermission && !hasPermission(requiredPermission)) return <AccessDenied />;

  return <Outlet />;
}
